<template>
  <v-snackbar
    v-model="state.activator"
    :bottom="y === 'bottom'"
    :left="x === 'left'"
    :multi-line="mode === 'multi-line'"
    :right="x === 'right'"
    :timeout="timeout"
    :top="y === 'top'"
    :color="state.type"
    :vertical="mode === 'vertical'"
  >
    {{ state.message }}
    <v-btn
      color="white"
      flat
      @click="shutdown()"
    >
      Close
    </v-btn>
  </v-snackbar>
</template>
<script>
export default {
    name: "GlobalToast",
    props: ["state",],
    data () {
        return {
            y: "top",
            x: null,
            mode: "",
            timeout: 4000,
        };
    },
    methods: {
        shutdown() {
            let newState = {
                activator: false,
                type: "",
                message: "",
            };
            this.$store.dispatch("AppState/setGlobalToastState", newState);
        },
    },
};
</script>
